function hexToRgb(hex: string): [number, number, number] {
  const n = parseInt(hex.replace('#', ''), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

function rgbToHex([r, g, b]: [number, number, number]): string {
  return '#' + [r, g, b].map((v) => Math.round(v).toString(16).padStart(2, '0')).join('');
}

// Generates `steps` evenly-spaced colors across the given hex stops (simple
// per-channel RGB lerp) — used for a single-hue ordinal ramp where a
// category's position (an ageing bucket, an allocation class) carries part
// of the meaning, without hardcoding a fixed-length palette per chart.
export function interpolateColors(stops: string[], steps: number): string[] {
  if (steps <= 1) return [stops[0]];
  const stopRgb = stops.map(hexToRgb);
  const segments = stopRgb.length - 1;
  const result: string[] = [];
  for (let i = 0; i < steps; i++) {
    const t = (i / (steps - 1)) * segments;
    const seg = Math.min(Math.floor(t), segments - 1);
    const localT = t - seg;
    const [r1, g1, b1] = stopRgb[seg];
    const [r2, g2, b2] = stopRgb[seg + 1];
    result.push(rgbToHex([r1 + (r2 - r1) * localT, g1 + (g2 - g1) * localT, b1 + (b2 - b1) * localT]));
  }
  return result;
}
